module.exports = __webpack_public_path__ + "img/about-bg2.a6c0af77.png";